export const DOSSIER_STATUSES = {
  NEW: "NEW",
  TO_QUALIFY: "TO_QUALIFY",
  DOCUMENTS_PENDING: "DOCUMENTS_PENDING",
  UNDER_ANALYSIS: "UNDER_ANALYSIS",
  INVESTMENT_COMMITTEE: "INVESTMENT_COMMITTEE",
  APPROVED_WITH_CONDITIONS: "APPROVED_WITH_CONDITIONS",
  APPROVED: "APPROVED",
  ON_HOLD: "ON_HOLD",
  REJECTED: "REJECTED",
  CONVERTED: "CONVERTED",
};

export const DOSSIER_STATUSES_LABELS = {
  [DOSSIER_STATUSES.NEW]: "Nouveau",
  [DOSSIER_STATUSES.TO_QUALIFY]: "À qualifier",
  [DOSSIER_STATUSES.DOCUMENTS_PENDING]: "En attente de pièces",
  [DOSSIER_STATUSES.UNDER_ANALYSIS]: "En analyse",
  [DOSSIER_STATUSES.INVESTMENT_COMMITTEE]: "En comité",
  [DOSSIER_STATUSES.APPROVED_WITH_CONDITIONS]: "Validé sous conditions",
  [DOSSIER_STATUSES.APPROVED]: "Validé",
  [DOSSIER_STATUSES.ON_HOLD]: "En attente",
  [DOSSIER_STATUSES.REJECTED]: "Refusé",
  [DOSSIER_STATUSES.CONVERTED]: "Converti",
};

export const DECISION_TYPES_LABELS = {
  APPROVED: "Validé",
  APPROVED_WITH_CONDITIONS: "Validé sous conditions",
  REQUEST_DOCS: "Demande d'éléments complémentaires",
  ON_HOLD: "Mis en attente",
  REJECTED: "Refusé",
  PENDING: "En attente",
  SUBMITTED: "Soumission au comité",
  OBSERVATION: "Observation",
};
